import { ItemType } from '@game/enums';
import type { ClientEquipmentItem } from '@game/shared-types';
import { ExamineHover } from '@game/ui';

import { ExamineItem } from '@components/ExamineItem/ExamineItem';
import { getDisplayName } from '@util/getDisplayName';

import type { MappedEquipmentItem } from '../../types/inventory.types';
import { EquipmentSkeleton } from './EquipmentSkeleton';

import './Equipment.less';

interface MappedEquipmentProps {
  equipment: ClientEquipmentItem[];
}

export const MappedEquipment = ({ equipment }: MappedEquipmentProps): MappedEquipmentItem[] => {
  return equipment.map((item): MappedEquipmentItem => {
    return {
      id: item.id,
      name: item.item.name,
      level: item.item.level,
      displayName: getDisplayName(item.item, item.quality),
      displayNameWithPopover: (
        <ExamineHover content={<ExamineItem itemA={{ ...item, id: 'equipment-item' }} />}>
          <span className="inventory-equipment-display-name">
            {item.item.qualityAdjectives[item.quality]} {item.item.name}
          </span>
        </ExamineHover>
      ),
      image: (
        <ExamineHover content={<ExamineItem itemA={{ ...item, id: 'equipment-item' }} />}>
          <div>
            <EquipmentSkeleton item={item} />
          </div>
        </ExamineHover>
      ),
      key: `${item.item.name}_${item.quality}`,
      equipmentType: item.item.type === ItemType.Equipment ? item.item.equipmentType : undefined,
      quality: item.quality,
      item: item.item,
      moduleSlots: item.moduleSlots,
      modules: item.modules,
    };
  });
};
